import React from 'react'
import { useParams } from 'react-router-dom'
import type { Blog } from '@ztechapps/common.contract'
import { useDocument } from '@ztechapps/common.hook'
import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { CenterScreen, LoadingContent } from '@ztechapps/webui.util'
import { BlogPreview } from '../BlogPreview'

const queries = buildGraphqlQuery('Blog', '_id title slug cover contentHtml status updatedAt')

const PreviewNotFound = () => (
  <CenterScreen>
    <div className="text-center">
      <h1>Article not found</h1>
      <p className="text-secondary">This preview link does not match any article.</p>
    </div>
  </CenterScreen>
)

const PreviewUnavailable = () => (
  <CenterScreen>
    <div className="text-center">
      <h1>Preview unavailable</h1>
      <p className="text-secondary">The preview could not be loaded. Please try again later.</p>
    </div>
  </CenterScreen>
)

// Standalone preview data screen — mounts outside any admin layout (no admin
// nav, no access gate), so the link opens with no login. The slug in the URL
// is the only credential. No status clause — renders a post of any status,
// unlike the public reader which filters to Active/Internal at the page level.
export const BlogPreviewScreen = () => {
  const { slug } = useParams<{ slug: string }>()
  const { document, loading, error } = useDocument<Blog>({ ...queries.singleConfig, filter: { slug } })

  if (loading) {
    return (
      <CenterScreen>
        <LoadingContent message="Loading preview..." subMessage="Please wait while the article loads..." />
      </CenterScreen>
    )
  }

  if (error) return <PreviewUnavailable />
  if (!document) return <PreviewNotFound />

  return <BlogPreview blog={document} />
}
